import React from "react";

function AccountIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.35 8.5C12.35 10.4332 10.828 12 8.95 12C7.07203 12 5.55 10.4332 5.55 8.5C5.55 6.5668 7.07203 5 8.95 5C10.828 5 12.35 6.5668 12.35 8.5ZM3 18.1879C3 15.4945 5.11969 13.3125 7.73609 13.3125H10.1639C12.7803 13.3125 14.9 15.4945 14.9 18.1879C14.9 18.6363 14.5467 19 14.1111 19H3.78891C3.35328 19 3 18.6363 3 18.1879ZM16.3875 13.5312V11.7812H14.6875C14.3342 11.7812 14.05 11.4887 14.05 11.125C14.05 10.7613 14.3342 10.4688 14.6875 10.4688H16.3875V8.71875C16.3875 8.35508 16.6717 8.0625 17.025 8.0625C17.3783 8.0625 17.6625 8.35508 17.6625 8.71875V10.4688H19.3625C19.7158 10.4688 20 10.7613 20 11.125C20 11.4887 19.7158 11.7812 19.3625 11.7812H17.6625V13.5312C17.6625 13.8949 17.3783 14.1875 17.025 14.1875C16.6717 14.1875 16.3875 13.8949 16.3875 13.5312Z"
        fill="white"
      />
    </svg>
  );
}

export default AccountIcon;
